import React, { useContext } from 'react';
import { ICustomersContext, CustomersContext } from '../../../../customersState/customersContext';
import Text from 'components/Text/Text';
import { Item } from './components/Item';
import classNames from 'classnames';
import style from './DeletedCustomersList.module.scss';

export const DeletedCustomersList: React.FC = () => {
	const { customers } = useContext<ICustomersContext>(CustomersContext);

	const nameHeadingClasses = classNames(style.name, style.heading);
	const deletingDateHeadingClasses = classNames(style.deletingDate, style.heading);
	const userHeadingClasses = classNames(style.user, style.heading);

	return (
		<div className={style.container} data-test="DeletedCustomersList">
			<div className={style.tableHeaders}>
				<Text
					className={nameHeadingClasses}
					translationNameSpace="listing"
					translationKey="nameLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={deletingDateHeadingClasses}
					translationNameSpace="listing"
					translationKey="deletingDateLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={userHeadingClasses}
					translationNameSpace="listing"
					translationKey="userLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			{customers.customers.map((item, index) => (
				<Item data={item} key={item.id} index={index} />
			))}
		</div>
	);
};
